import React from "react";
import { ITypographyProps } from "../../@interfaces";



const Title = ({ children, className, ...props }: ITypographyProps) => {
  return (
    <h1
      className={`text-base font-semibold text-gray-700 ${className ?? ""}`}
      {...props}
    >
      {children}
    </h1>
  )
}

export default Title;